import React from 'react'
import { RepoIcon } from '@primer/octicons-react'

const EducationInfo = ({
  profesionuoficio,
  detalleeducacional,
  niveleducacional,
  ocupacion,
}) => {
  return (
    <div>
      {ocupacion && <h3 className="mb-2 leading-none">{ocupacion}</h3>}

      <h4 className="mb-2 leading-none">
        <RepoIcon verticalAlign="bottom" className="mr-1" />
        <strong>{profesionuoficio}</strong>
      </h4>
      {detalleeducacional ? (
        <h4 className="mb-2 leading-none">{detalleeducacional}</h4>
      ) : (
        niveleducacional && (
          <h4 className="mb-2 leading-none">{niveleducacional}</h4>
        )
      )}
    </div>
  )
}

export default EducationInfo
